module.exports = __webpack_public_path__ + "img/kafe.eadeefca.jpg";